var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkilleditionLp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14114",
    "data-name": "Group 14114",
    transform: "translate(-374 -3872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14100",
    "data-name": "Group 14100",
    transform: "translate(-903 -1549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1277 5421)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14113",
    "data-name": "Group 14113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5228",
    "data-name": "Path 5228",
    d: "M275.588,258.575l-6.463,1.435v9.245l6.745-1.5a.659.659,0,0,0,.519-.643v-7.894a.658.658,0,0,0-.8-.643Zm-.929,7.132-3.522.784a.661.661,0,0,1-.286-1.29l3.522-.784a.661.661,0,0,1,.286,1.29Zm0-3.082-3.522.784a.661.661,0,0,1-.286-1.29l3.522-.784a.661.661,0,0,1,.286,1.29Z",
    transform: "translate(127.459 3633.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5229",
    "data-name": "Path 5229",
    d: "M98.5,259.21V267.1a.655.655,0,0,0,.515.643l6.749,1.5V260L99.3,258.567a.656.656,0,0,0-.8.643Zm2.012,2.03,3.522.784a.661.661,0,1,1-.286,1.29l-3.522-.784a.661.661,0,0,1,.286-1.29Zm0,3.082,3.522.784a.661.661,0,1,1-.286,1.29l-3.522-.784a.661.661,0,0,1,.286-1.29Z",
    transform: "translate(289.5 3633.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5230",
    "data-name": "Path 5230",
    d: "M220.352,198.411h-3.962A2.019,2.019,0,1,0,220.352,198.411Z",
    transform: "translate(177.554 3690.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5231",
    "data-name": "Path 5231",
    d: "M197.321,59.8h3.236l.85-1.206a3.01,3.01,0,1,0-4.931,0Z",
    transform: "translate(196.983 3827.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5232",
    "data-name": "Path 5232",
    d: "M332.864,153.648c.217.1.777.523,1.028.492a.663.663,0,0,0,.331-1.232l-.7-.4A.66.66,0,0,0,332.864,153.648Z",
    transform: "translate(67.241 3734.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5233",
    "data-name": "Path 5233",
    d: "M140.418,152.51l-.7.4a.663.663,0,0,0,.331,1.233c.254.03.808-.39,1.028-.492A.661.661,0,0,0,140.418,152.51Z",
    transform: "translate(250.663 3734.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5234",
    "data-name": "Path 5234",
    d: "M346.4,101.4a.66.66,0,0,0,.66.66h.806a.66.66,0,0,0,0-1.321h-.806a.66.66,0,0,0-.66.66Z",
    transform: "translate(54.075 3783.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5235",
    "data-name": "Path 5235",
    d: "M123.94,102.059h.806a.66.66,0,0,0,0-1.321h-.806a.66.66,0,1,0,0,1.321Z",
    transform: "translate(265.966 3783.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5236",
    "data-name": "Path 5236",
    d: "M333.276,42.581c.254.03.808-.39,1.028-.492a.66.66,0,0,0-.66-1.144l-.7.4A.663.663,0,0,0,333.276,42.581Z",
    transform: "translate(67.159 3840.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5237",
    "data-name": "Path 5237",
    d: "M139.637,42.094c.217.1.777.523,1.028.492A.663.663,0,0,0,141,41.353l-.7-.4A.661.661,0,0,0,139.637,42.094Z",
    transform: "translate(250.745 3840.143)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkilleditionLp);
export default __webpack_public_path__ + "static/media/skilledition-lp.234dd59a9159c78a38d927369e7ed03b.svg";
export { ForwardRef as ReactComponent };